import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const Modal = ({ open, onClose, title, children, footer }) => {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/60 z-50"
            onClick={onClose}
            data-testid="admin-modal-backdrop"
          />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="w-full max-w-lg max-h-[90vh] bg-white flex flex-col shadow-2xl pointer-events-auto"
              data-testid="admin-modal"
            >
              <div className="flex justify-between items-center px-8 pt-6 pb-4 border-b border-gray-100 flex-shrink-0">
                <h3 className="font-heading text-2xl font-bold">{title}</h3>
                <button
                  onClick={onClose}
                  className="p-2 hover:bg-gray-100 rounded"
                  data-testid="admin-modal-close"
                >
                  <X size={20} />
                </button>
              </div>
              <div className="overflow-y-auto px-8 py-6 flex-1 min-h-0">
                {children}
              </div>
              {footer && (
                <div className="px-8 py-4 border-t border-gray-100 bg-white flex-shrink-0" data-testid="admin-modal-footer">
                  {footer}
                </div>
              )}
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
};

export default Modal;
